import styled from 'styled-components';
import { breakpoint } from '../theme/breakpoint';
import { Container } from '../styled/containers';
import { FormFieldWrapper, FormWrapper } from '../form/styles';

export const StyledContainer = styled(Container)`
  display: flex;
  padding-top: ${({ theme }) => theme.spacing.xlarge};
  padding-bottom: ${({ theme }) => theme.spacing.xlarge};
  flex-direction: column;

  ${breakpoint.tablet`
    flex-direction: row;
  `};
`;

export const SignupFormWrapper = styled.section`
  margin-bottom: ${({ $removeMarginBottom, theme }) =>
    $removeMarginBottom ? '0' : theme.spacing.large};

  // override embedded container within form compoent
  ${Container} ${Container} {
    padding: 0;

    ${breakpoint.tablet`
      padding: ${({ theme }) => `0 0 0 ${theme.spacing.tiny}`}
    `};
  }
`;

export const SignupFormIntroText = styled.div`
  flex: 0 0 50%;
  margin-bottom: 0;
`;

export const PrivacyLine = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;

export const FormContainer = styled.div`
  flex: 0 0 50%;
  margin-bottom: 0;

  > div {
    margin: 0;
  }

  ${FormWrapper} {
    margin: 0;
  }

  ${FormFieldWrapper} {
    margin: 0;

    button {
      width: 100%;

      ${breakpoint.tablet`
        width: auto;
      `};
    }
  }

  .postcode_wrapper {
    margin-bottom: ${({ theme }) => theme.spacing.tiny};
  }
`;

export const Header = styled.h2`
  margin-top: 0;
  text-transform: uppercase;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;

export const BodyText = styled.div`
  max-width: 23em;
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;
